import api from '../api'
import {LINKS_TABLE_TYPES} from '../../mixins/linkMixin'

const getPagerSizeFromLocalStorage = (type) => {
  return JSON.parse(localStorage
    ? (localStorage.getItem(`reviews:${type}:pager:pageSize`) || 10)
    : 10)
}

const pagerInitalState = {
  items: [],
  page: 1,
  count: undefined,
  pagesCount: undefined,
  itemsPerPage: [5, 10, 25, 50, 100, 200] // This is a readonly property.
}

const state = {
  all: [],
  reviewAndCommentsLinks: {
    ...pagerInitalState,
    pageSize: getPagerSizeFromLocalStorage(LINKS_TABLE_TYPES.REVIEW_AND_COMMENTS)
  },
  quickPreviewLinks: {
    ...pagerInitalState,
    pageSize: getPagerSizeFromLocalStorage(LINKS_TABLE_TYPES.REVIEW_AND_COMMENTS)
  },
  linksSearchTerms: null
}

const actions = {
  getLinks: ({ state, commit }, typeSelected) => {
    const type = typeSelected || LINKS_TABLE_TYPES.QUICK_PREVIEW
    const pager = typeSelected === LINKS_TABLE_TYPES.QUICK_PREVIEW ? state.quickPreviewLinks : state.reviewAndCommentsLinks
    return api.getAllLinks({
      ...pager,
      type,
      searchTerms: state.linksSearchTerms
    }).then(data => {
      return commit('setAllLinks', {...data, type})
    })
  },
  deleteLink: ({ state, commit }, id) => {
    return api.deleteSingleLink(id)
  },
  refreshLink: ({ state, commit }, id) => {
    return api.refreshSingleLink(id)
  },
  updateLink: ({ state, commit }, data) => {
    return api.updateSingleLink(data)
  },
  setPagerData: ({ state, commit }, pageData) => {
    const {pageSize, ...rest} = pagerInitalState
    return commit('setPagerData', pageData || rest)
  },
  setLinksSearchTerms: ({state, commit}, value) => {
    return commit('setLinksSearchTerms', value)
  },
  validateReviewClone: ({state, commit}, hashid) => {
    return api.validateClone({id: hashid})
  }
}

const mutations = {
  setAllLinks (state,
    {type, items, page, pageSize, count, pagesCount}
  ) {
    if (localStorage) {
      localStorage.setItem(`reviews:${type}:pager:pageSize`,
        pageSize || (type === LINKS_TABLE_TYPES.REVIEW_AND_COMMENTS ? state.reviewAndCommentsLinks.pageSize : state.quickPreviewLinks.pageSize))
    }

    if (type === LINKS_TABLE_TYPES.REVIEW_AND_COMMENTS) {
      state.reviewAndCommentsLinks = {
        items: items || state.reviewAndCommentsLinks.items,
        page: page || state.reviewAndCommentsLinks.page,
        pageSize: getPagerSizeFromLocalStorage(type),
        count: count || state.reviewAndCommentsLinks.count,
        pagesCount: pagesCount || state.reviewAndCommentsLinks.pagesCount,
        itemsPerPage: pagerInitalState.itemsPerPage
      }
    } else {
      state.quickPreviewLinks = {
        items: items || state.quickPreviewLinks.items,
        page: page || state.quickPreviewLinks.page,
        pageSize: getPagerSizeFromLocalStorage(type),
        count: count || state.quickPreviewLinks.count,
        pagesCount: pagesCount || state.quickPreviewLinks.pagesCount,
        itemsPerPage: pagerInitalState.itemsPerPage
      }
    }
  },
  setPagerData (state, {type, page, pageSize, count, pagesCount}) {
    if (localStorage) {
      localStorage.setItem(`reviews:${type}:pager:pageSize`,
        pageSize || (type === LINKS_TABLE_TYPES.REVIEW_AND_COMMENTS ? state.reviewAndCommentsLinks.pageSize : state.quickPreviewLinks.pageSize))
    }

    if (type === LINKS_TABLE_TYPES.REVIEW_AND_COMMENTS) {
      state.reviewAndCommentsLinks = {
        items: state.reviewAndCommentsLinks.items,
        page: page || state.reviewAndCommentsLinks.page,
        pageSize: getPagerSizeFromLocalStorage(type),
        count: count || state.reviewAndCommentsLinks.count,
        pagesCount: pagesCount || state.reviewAndCommentsLinks.pagesCount,
        itemsPerPage: pagerInitalState.itemsPerPage
      }
    } else {
      state.quickPreviewLinks = {
        items: state.quickPreviewLinks.items,
        page: page || state.quickPreviewLinks.page,
        pageSize: getPagerSizeFromLocalStorage(type),
        count: count || state.quickPreviewLinks.count,
        pagesCount: pagesCount || state.quickPreviewLinks.pagesCount,
        itemsPerPage: pagerInitalState.itemsPerPage
      }
    }
  },
  setLinksSearchTerms (state, value) {
    state.linksSearchTerms = value
  }
}

const getters = {
  all: state => {
    return state.all
  },
  reviewAndCommentsLinks: state => state.reviewAndCommentsLinks,
  quickPreviewLinks: state => state.quickPreviewLinks
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/links.js